module.exports = __webpack_public_path__ + "img/26_BF4_mourn_the_flooded_pines.20474cdd.jpg";